export const ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE = 25;

export const ADMIN_PROSPECT_FOLLOW_UP_BUCKETS = Object.freeze([
  'overdue',
  'today',
  'upcoming',
  'all',
]);

export const ADMIN_PROSPECT_PUBLIC_RESPONSE_PROCESSING_STATES = Object.freeze([
  'needs_processing',
  'processed',
]);

export const ADMIN_PROSPECT_PUBLIC_RESPONSE_PROCESSING_LIST_STATES = Object.freeze([
  'needs_processing',
  'processed',
]);

export const ADMIN_PROSPECT_ACTIVE_OPPORTUNITY_STATUSES = Object.freeze([
  'contacted',
  'follow_up',
  'owner_responded',
  'qualified',
]);

function clampPageSize(pageSize) {
  const size = Number(pageSize);
  return Number.isFinite(size) && size > 0
    ? Math.floor(size)
    : ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE;
}

function optionalToken(pageToken) {
  if (pageToken == null || pageToken === '') return null;
  return String(pageToken);
}

function isVersionToken(value) {
  return (
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Number.isInteger(value.s) &&
    Number.isInteger(value.n) &&
    value.n >= 0 &&
    value.n < 1e9
  );
}

/**
 * @param {{
 *   pageSize?: number,
 *   pageToken?: string | null,
 *   processingState?: 'needs_processing' | 'processed',
 * }} [params]
 */
export function buildListAdminProspectResponsesToProcessRequest({
  pageSize = ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE,
  pageToken,
  processingState = 'needs_processing',
} = {}) {
  const request = {
    pageSize: clampPageSize(pageSize),
    processingState:
      processingState === 'processed' ? 'processed' : 'needs_processing',
  };
  const token = optionalToken(pageToken);
  if (token) request.pageToken = token;
  return request;
}

/**
 * @param {{
 *   campaignId: string,
 *   mailingId: string,
 *   intent: string,
 *   processingState: 'needs_processing' | 'processed',
 *   expectedUpdatedAtVersion?: { s: number, n: number } | string | null,
 *   expectedUpdatedAt?: string | null,
 * }} params
 */
export function buildSetAdminProspectPublicResponseProcessingRequest({
  campaignId,
  mailingId,
  intent,
  processingState,
  expectedUpdatedAtVersion,
  expectedUpdatedAt,
} = {}) {
  const request = {
    campaignId: String(campaignId || '').trim(),
    mailingId: String(mailingId || '').trim(),
    intent: String(intent || '').trim(),
    processingState: String(processingState || '').trim(),
  };
  if (isVersionToken(expectedUpdatedAtVersion)) {
    request.expectedUpdatedAtVersion = {
      s: expectedUpdatedAtVersion.s,
      n: expectedUpdatedAtVersion.n,
    };
  } else if (
    expectedUpdatedAtVersion != null &&
    typeof expectedUpdatedAtVersion === 'string' &&
    expectedUpdatedAtVersion.trim()
  ) {
    request.expectedUpdatedAtVersion = expectedUpdatedAtVersion.trim();
  } else if (expectedUpdatedAt != null && String(expectedUpdatedAt).trim()) {
    request.expectedUpdatedAt = String(expectedUpdatedAt).trim();
  }
  return request;
}

/**
 * @param {{ bucket?: string, pageSize?: number, pageToken?: string | null }} [params]
 */
export function buildListAdminProspectFollowUpsRequest({
  bucket = 'all',
  pageSize = ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE,
  pageToken,
} = {}) {
  const request = {
    bucket: String(bucket || 'all'),
    pageSize: clampPageSize(pageSize),
  };
  const token = optionalToken(pageToken);
  if (token) request.pageToken = token;
  return request;
}

/**
 * @param {{
 *   pageSize?: number,
 *   pageToken?: string | null,
 *   status?: string | null,
 * }} [params]
 */
export function buildListAdminProspectActiveOpportunitiesRequest({
  pageSize = ADMIN_PROSPECT_FOLLOW_UP_WORKSPACE_PAGE_SIZE,
  pageToken,
  status = null,
} = {}) {
  const request = { pageSize: clampPageSize(pageSize) };
  const token = optionalToken(pageToken);
  if (token) request.pageToken = token;
  if (status && ADMIN_PROSPECT_ACTIVE_OPPORTUNITY_STATUSES.includes(status)) {
    request.status = status;
  }
  return request;
}
